let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fgAR7")).then(() => parcelRequire('eU4jz'));